import React from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";
import { Link } from "react-router-dom";

import { Grid, Row, Col } from "Common/Grid";
import Header from "Cobalt/Header";

import makeBem from "Utils/makeBem";

const bem = makeBem("ProcessOverview");
type StepProps = {
  readonly component?: React.ElementType | typeof Link;
  readonly className?: string;
  readonly title?: string;
  readonly subtitle?: string;
  readonly href?: string;
  readonly to?: string;
  readonly children?: React.ReactNode;
  readonly status?: "past" | "present" | "future";
  readonly order?: "first" | "middle" | "last";
};
export const ProcessStep = ({ component, className, children, title, subtitle, href, status = "future", order, ...rest }: StepProps) => {
  component = component || (href ? "a" : "div");
  const statusClass = isIntuit() ? `intuit-${status}` : status;
  const orderClass = order ? `intuit-${order}` : null;
  return React.createElement(
    component,
    {
      className: classnames(bem("Step", isIntuit() ? "intuit" : null), bem("Step", statusClass), bem("Step", orderClass), className),
      href,
      ...rest,
    },
    isIntuit() && <div className={bem("StepBar--intuit")} />,
    children || <span key={0} className={bem("StepTitle")} children={title || "\u00a0"} />,
    !isIntuit() && <span className={bem("StepBar")} />,
  );
};

type OverviewProps = {
  readonly className?: string;
  readonly children: React.ReactNode;
  readonly topHeaderSection?: React.ReactNode;
};

const stepIndex = (children) => {
  let si = children.length;

  for (let i = 0; i < children.length; i++) {
    if (children[i].props.status === "present") {
      si = i + 1;
    }
  }

  return si;
};

export const ProcessOverview = ({ className, children, topHeaderSection, ...rest }: OverviewProps) => {
  const filteredChildren = React.Children.toArray(children).filter((o) => o);
  return (
    <div className={bem("Container", isIntuit() ? "intuit" : null)} {...rest}>
      <Grid>
        {isIntuit() && (
          <Row>
            <Col md={6} className={classnames("text-left")}>
              {topHeaderSection}
            </Col>
            <Col md={6} className={classnames("text-right")}>
              <Header level={7} mt={3} mr={5}>
                {stepIndex(filteredChildren)} of {filteredChildren.length}
              </Header>
            </Col>
          </Row>
        )}
        <Row className={classnames(bem(), className)}>
          <Col className={bem("StepsContainer")}>{filteredChildren}</Col>
        </Row>
        {!isIntuit() && topHeaderSection && (
          <Row>
            <Col className={classnames("text-left")}>{topHeaderSection}</Col>
          </Row>
        )}
      </Grid>
    </div>
  );
};
